import { MainPageLayout } from 'shared/components/MainPageLayout';
import { MortgageWrapperContainer } from 'shared/containers/MortgageWrapperContainer';
import { PresentationBlockContainer } from 'shared/containers/PresentationBlockContainer';

export const MainPage = () => {
  return <MainPageLayout presentationBlock={<PresentationBlockContainer />} mainBlock={<MortgageWrapperContainer />} />;
};
